// extracted by mini-css-extract-plugin
export default {"alert":"EvaluationAlert_alert__c9csp","approved":"EvaluationAlert_approved__Z1Kak","failed":"EvaluationAlert_failed__T9MYh"};